module.exports = __webpack_public_path__ + "img/special_homeStar.bbefde5c.png";